"use client";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../shadcn/DropDownMenu";
import { getCalendarLinks } from "~/utils/time";
import { RiCalendarEventFill } from "react-icons/ri";
import { Button } from "../v3/themed/Button";
import { ButtonCustomization } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

type EventProps = {
    event?: {
        community?: {
            name?: string;
        };
        slug: string;
        name: string;
        startTime: Date;
        endTime?: Date | null;
        timezone: string;
        description?: string | null;
        location: string;
    };
    customization?: ButtonCustomization;
};

export const AddToCalendarButtons: React.FC<EventProps> = ({
    event,
    customization,
}) => {
    if (!event) return null;
    const links = getCalendarLinks(event, event.community?.name);
    return (
        <DropdownMenu modal={false}>
            <DropdownMenuTrigger asChild>
                <Button
                    variant="default"
                    className={cn(
                        "flex gap-2 rounded-lg bg-white/15 p-2 text-xs text-white",
                        customization?.default,
                    )}
                >
                    <RiCalendarEventFill /> Add to calendar
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="start"
                side="bottom"
                className="bg-white text-primary"
            >
                <DropdownMenuItem>
                    <a
                        href={links.google}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        GOOGLE CALENDAR
                    </a>
                </DropdownMenuItem>
                <DropdownMenuItem>
                    <a
                        href={links.outlook}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        OUTLOOK CALENDAR
                    </a>
                </DropdownMenuItem>
                <DropdownMenuItem>
                    <a
                        href={links.apple}
                        target="_blank"
                        rel="noopener noreferrer"
                        download={`${event.slug}.ics`}
                    >
                        APPLE CALENDAR
                    </a>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
